$(document).ready(function () {
  const swiperOne = new Swiper('.swiper-one',{
    breakpoints: {
      320: {
        slidesPerView: 2.5,
        spaceBetween: 15
      },
      769: {
        slidesPerView: 3.5,
        spaceBetween: 15
      },
      1242: {
        slidesPerView: 4,
        spaceBetween: 15
      }
    }
  })
  const swiperTwo = new Swiper('.swiper-two',{
    breakpoints: {
      320: {
        slidesPerView: 2.5,
        spaceBetween: 15
      },
      769: {
        slidesPerView: 3.5,
        spaceBetween: 15
      },
      1242: {
        slidesPerView: 4,
        spaceBetween: 15
      }
    }
  })
})